import { useEffect, useState } from "react";
// @mui
import { alpha } from "@mui/material/styles";
import { Box, MenuItem, Stack, IconButton, Popover } from "@mui/material";
import i18next from "i18next";
import LANGS from "../i18n/langs";

export default function LanguagePopover() {
  const [open, setOpen] = useState(null);
  const language = JSON.parse(localStorage.getItem("@wirasana_lang"));

  const handleSelect = (v) => {
    localStorage.setItem("@wirasana_lang", JSON.stringify(v));
    i18next.changeLanguage(v.value);
    handleClose();
  };

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  useEffect(() => {
    if (!language) {
      localStorage.setItem("@wirasana_lang", JSON.stringify(LANGS[0]));
      window.location.reload();
    }
  }, []);

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          padding: 0,
          ...(open && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.focusOpacity
              ),
          }),
        }}
      >
        <img
          src={language?.icon}
          alt={language?.label}
          style={{ width: 44, height: 44 }}
        />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ zIndex: 9999999 }}
        PaperProps={{
          sx: {
            p: 1,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Stack spacing={0.75}>
          {LANGS.map((option, i) => (
            <MenuItem
              key={option.value}
              selected={option.value === language?.value}
              onClick={() => handleSelect(option)}
            >
              <Box
                component="img"
                alt={option.label}
                src={option.icon}
                sx={{ width: 28, mr: 2 }}
              />

              {option.label}
            </MenuItem>
          ))}
        </Stack>
      </Popover>
    </>
  );
}
